(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vaschy-article"]) return;
  try {
    
  if (!customElements.get('vaschy-article-reader')) {
    customElements.define('vaschy-article-reader', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const body = this.querySelector('[data-article-body]');
        const headings = Array.from(body.querySelectorAll('h2, h3')).filter(heading => heading.textContent.trim());
        const list = this.querySelector('[data-toc-list]');
        if (list && headings.length > 1) {
          headings.forEach((heading, index) => {
            if (!heading.id) heading.id = this.id + '-story-heading-' + index;
            const item = document.createElement('li');
            item.className = heading.tagName === 'H3' ? 'vc-toc__subheading' : '';
            const link = document.createElement('a');
            link.href = '#' + heading.id;
            link.textContent = heading.textContent;
            item.append(link);
            list.append(item);
          });
          this.querySelector('[data-toc-aside]').hidden = false;
          this.classList.add('vc-reader--has-toc');
          if (window.matchMedia('(max-width: 899px)').matches) this.querySelector('.vc-toc').open = false;
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              list.querySelectorAll('a').forEach(link => {
                if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
                else link.removeAttribute('aria-current');
              });
            });
          }, { rootMargin: '-15% 0px -65% 0px' });
          headings.forEach(heading => this.observer.observe(heading));
        }
        const progress = this.querySelector('[data-reading-progress]');
        const bar = this.querySelector('[data-progress-bar]');
        progress.hidden = false;
        const updateProgress = () => {
          this.frame = null;
          const bounds = body.getBoundingClientRect();
          const distance = Math.max(1, bounds.height - window.innerHeight * 0.6);
          bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, (window.innerHeight * 0.25 - bounds.top) / distance)) + ')';
        };
        const scheduleProgress = () => { if (!this.frame) this.frame = requestAnimationFrame(updateProgress); };
        window.addEventListener('scroll', scheduleProgress, { passive: true, signal });
        window.addEventListener('resize', scheduleProgress, { passive: true, signal });
        updateProgress();
        const copy = this.querySelector('[data-copy-link]');
        if (copy && navigator.clipboard && window.isSecureContext) {
          copy.hidden = false;
          copy.addEventListener('click', async () => {
            const status = this.querySelector('[data-copy-status]');
            try { await navigator.clipboard.writeText(copy.dataset.url); status.textContent = this.dataset.copied; }
            catch { status.textContent = this.dataset.copyError; }
          }, { signal });
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = null;
        this.querySelector('[data-toc-list]')?.replaceChildren();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
